module.exports = __webpack_public_path__ + "static/media/energy-flexibility-simulator-img-006.7cc68dbb.jpg";